export const elementAlertConfig = {
  'Multiple Choice': {
    alertType: 'warning',
    alertMessage: 'Add choices',
    actionRequired: ({ entry_values = [], reference_data_id = '', data_source_context_id = '' }) =>
      entry_values.length === 0 && !reference_data_id && !data_source_context_id
  },
  'Single Choice': {
    alertType: 'warning',
    alertMessage: 'Add choices',
    actionRequired: ({ entry_values = [], reference_data_id = '', data_source_context_id = '' }) =>
      entry_values.length === 0 && !reference_data_id && !data_source_context_id
  },
  'Dropdown': {
    alertType: 'warning',
    alertMessage: 'Add choices',
    actionRequired: ({ entry_values = [], reference_data_id = '', data_source_context_id = '' }) =>
      entry_values.length === 0 && !reference_data_id && !data_source_context_id
  },
}
